import './Phone.css';
import {Box} from "@mui/material";


export default function Phone() {
    // {
    //     phone: {
    //         [theme.breakpoints.up('md')]: {
    //             right: "25%",
    //         },
    //         [theme.breakpoints.down('sm')]: {
    //             top: "57%",
    //                 left: "280px",
    //                 transform: "scale(0.6) rotate(-30deg) skewX(30deg)",
    //         },
    //     }
    // }

  return (
    <Box
        sx={{
            position: "absolute",
            transform: "scale(0.8) rotate(-30deg) skewX(30deg)",
            zIndex: -5,
        }}
    >
      <div className="phone-back">
        <div className="phone-left-side">
          <div className="phone-antenna"/>
          <div className="phone-button top"/>
          <div className="phone-button"/>
          <div className="phone-button bottom"/>
          <div className="phone-antenna bottom"/>
        </div>
        <div className="phone-bottom">
          <div className="phone-antenna"/>
          <div className="bottom-speaker">
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
          </div>
          <div className="phone-screw">
            <div/>
          </div>
          <div className="phone-charger">
          </div>
          <div className="phone-screw right">
            <div/>
          </div>
          <div className="bottom-speaker right">
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
          </div>
          <div className="phone-antenna right"/>
        </div>
      </div>
      <div className="phone-screen"/>
      <div className="phone-display">
        <div className="phone-notch">
          <div className="phone-speaker"/>
        </div>
        <div className="display-content"/>
      </div>
      <div className="phone-reflections">
        <div className="reflection-1"/>
        <div className="reflection-2"/>
        <div className="reflection-3"/>
        <div className="reflection-4"/>
        <div className="reflection-5"/>
        <div className="reflection-6"/>
        <div className="reflection-7"/>
      </div>
    </Box>
  );
}